module.exports = __webpack_public_path__ + "img/Driver.8bdea8ac.png";